import React from 'react';
import _ from 'lodash';
import CommonModal from './common/Modal';
import { FormList, FormListItem, FormElement } from '../CommonFormComponents';
import { Description } from '../Description';
import { messageUtility } from '../../utilities/messageUtility';

export const ForemanRegistConfirmDialog = ({
  visible,
  onCancel,
  onConfirm,
  companyName,
  companyAddress,
  values,
}) => {
  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className='dialog dialog--wide dialog--modal'>
            <div className='dialog__header'>
              <span className='dialog__title'>職長新規登録</span>
            </div>
            <div className='dialog__body'>
              <div className='dialog__row dialog__text'>
                <Description type='primary'>
                  <React.Fragment>
                    {messageUtility.getMessage('I-000-156')}
                    <br />
                    {messageUtility.getMessage('I-000-157')}
                  </React.Fragment>
                </Description>
              </div>
              <div className='InviteForm'>
                <FormList>
                  <FormListItem label='会社名'>
                    <FormElement>
                      <p>{companyName}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='住所'>
                    <FormElement>
                      <p>{companyAddress}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='姓'>
                    <FormElement>
                      <p>{values.name_sei}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='名'>
                    <FormElement>
                      <p>{values.name_mei}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='せい'>
                    <FormElement>
                      <p>{values.kana_sei}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='めい'>
                    <FormElement>
                      <p>{values.kana_mei}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='ユーザーID'>
                    <FormElement>
                      <p>{values.login_id}</p>
                    </FormElement>
                  </FormListItem>
                  <FormListItem label='メールアドレス'>
                    <FormElement>
                      <p>{values.email}</p>
                    </FormElement>
                  </FormListItem>
                </FormList>
              </div>
            </div>
            <div className='dialog__footer dialog__footer--horizontal'>
              <button className='btn-fixedsize--sub' onClick={onCancel}>
                {messageUtility.getMessage('I-000-147')}
              </button>
              <button className='btn-fixedsize--effective' onClick={onConfirm}>
                {messageUtility.getMessage('I-000-148')}
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ForemanRegistConfirmDialog.jsx